import type { ConceptDataobject, Graph } from "@lr-notitia/notitia-designer/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const conceptDataobjects = (graph: Ref<Graph>) =>
	computed<ConceptDataobject[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "dataobject" && node.layer === "concept"
			) as ConceptDataobject[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology || {} })
				.toLocaleLowerCase()
				.localeCompare(
					symbolsStore.term({ id: b.refersTo, terminology: b.terminology || {} }).toLocaleLowerCase()
				)
		);
	});
export function conceptDataobject(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => byId(id, graph),
		getAllTopLevel: (dId: string) => getAllTopLevel(graph, dId),
	};
}

function byId(id: string, graph: Ref<Graph>): ConceptDataobject | undefined {
	let hit = graph.value.nodes[id];
	return hit && hit.type === "dataobject" && hit.layer === "concept" ? (hit as ConceptDataobject) : undefined;
}

function getAllTopLevel(graph: Ref<Graph>, dId: string): ConceptDataobject[] {
	const dataobjects = Object.values(graph.value.nodes).filter(
		(node) => node.type === "dataobject" && node.layer === "concept"
	) as ConceptDataobject[];
	return dataobjects.filter((dataobject) => {
		return !dataobjects.find((d) => d.composedBy.includes(dataobject.id));
	});
}
